import React from "react";

export interface LeaderboardsMetricHelpModalProps {
	metric: "totalXp" | "totalTrophies" | "newLevelReached";
	isAcademyUser: boolean;
}

export const LeaderboardsMetricHelpModal: React.FC<LeaderboardsMetricHelpModalProps> = ({
	metric,
	isAcademyUser,
}) => {
	if (metric === "totalXp") {
		if (isAcademyUser) {
			return (
				<div>
					<p>
						Leaderboard scores are determined by a student's XP for the course
						they are enrolled in.
					</p>
					<p>
						XP can be earned by solving problems, earning stars and trophies,
						reading the digital Guide book, and watching videos.
					</p>
				</div>
			);
		} else {
			return (
				<div>
					<p>
						Gain Experience Points (XP) by earning stars in lessons, reading the
						Guide, and watching videos in BA Online.
					</p>
					<p>
						The XP Leaderboard shows the students who earned the most XP in the
						given time period.
					</p>
				</div>
			);
		}
	} else if (metric === "totalTrophies") {
		return (
			<div>
				<p>
					Some lessons in Beast Academy have hidden trophy problems that are
					revealed if you earn 3 stars.
				</p>
				<p>
					The Trophies Leaderboard shows students who answered the most trophy
					problems in the given time period.
				</p>
			</div>
		);
	} else if (metric === "newLevelReached") {
		return (
			<div>
				<p>
					You achieve new levels in Beast Academy Online by earning XP. The
					higher your level, the more XP it takes to level up!
				</p>
				<p>
					The New Levels Earned Leaderboard ranks students who have leveled up
					in the given time period.
				</p>
			</div>
		);
	}
	return null;
};
